var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDashboWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 137",
    style: {
      enableBackground: "new 0 0 137 137"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF470F;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_dashbo_orange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.5,
    cy: 68.5,
    r: 68.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.9,31.9H60.1L33.2,95.5l16.6,0H87h0l16.7,0L76.9,31.9z M55.2,80.1L68.4,48l13.1,32L55.2,80.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDashboWhite);
export default __webpack_public_path__ + "static/media/logo_dashbo_white.bc7b921fc7fc4f6df676cc69d3f59c90.svg";
export { ForwardRef as ReactComponent };